import { Font, StyleSheet } from "@react-pdf/renderer";
import montserrat from "../../../fonts/Times-New-Roman.ttf";
import montserratBold from "../../../fonts/Times-New-Roman-Bold.ttf";
// Montserrat ЗАМЕНЕН НА Times-New-Roman
Font.register({ family: 'Montserrat', src: montserrat, fontWeight: 'normal' });
Font.register({ family: 'Montserrat', src: montserratBold, fontWeight: 'bold' });


export const pdfStyles = StyleSheet.create({
    page: { fontFamily: 'Montserrat', fontSize: 12, borderWidth: 30, paddingLeft: 40 },
    center: { textAlign: 'center' },
    centerVertically: { marginTop: 5 },
    centerVerticallyNew: { marginTop: 28 },
    underline: { textDecoration: 'underline' },
    title: { fontWeight: 'bold', fontSize: 22 },
    subTitle: { fontWeight: 'bold', fontSize: 18 },
    subSubTitle: { fontWeight: 'bold', fontSize: 17 },
    continuation: { fontSize: 12 },
    bold: { fontWeight: 'bold' },
    centerFlex: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    smaller: { fontSize: 10 },

    /* ALIGNMENT */
    mb20: { marginBottom: 20 },
    mt5: { marginTop: 5 },
    mt50: { marginTop: 50 },
    mb10: { marginBottom: 10 },
    mb3: { marginBottom: 3 },
    ml3: { marginLeft: 3 },
    ml10: { marginLeft: 30 },
    width70: { width: '70%', marginLeft: '15%' },
    width80: { width: '80%', marginLeft: '10%' },
    width90: { width: '90%', marginLeft: '5%' },
    headMargin: { marginTop: 35, marginRight: '80' },
    heightAuto: { flexDirection: "row" },
    smallHeight: { maxHeight: 20 },
    mediumHeight: { maxHeight: 40 },
    bigHeight: { maxHeight: 65 },
    smHeight: { height: 20 },
    medHeight: { height: 40 },
    /* ALIGNMENT */

    /* TABLE STYLES */
    text: { whiteSpace: 'normal', height: 60, fontSize: 10 },
    textX: {
        fontFamily: 'Montserrat',
        fontSize: 12,
        paddingLeft: 10,
        borderWidth: 0,
        marginLeft: 20,
        marginRight: 20,
        textAlign: 'center'
    },
    textZ: { fontFamily: 'Montserrat', fontSize: 12, paddingLeft: 10, borderWidth: 0, margin: 20, textAlign: 'center' },
    table: { wordWrap: 'break-word', width: "96%", marginTop: '-20', margin: '2%', flexDirection: "column", borderCollapse: 'collapse', borderSpacing: '0' },
    tableRow: { flexDirection: "row", marginBottom: 0, padding: 0, maxHeight: 60, borderCollapse: 'collapse' },
    tableRowFirst: { flexDirection: "row", marginBottom: 0, padding: 0, maxHeight: 60, minHeight: 50 },
    tableSmallRow: { flexDirection: "row", marginBottom: 0, padding: 0, maxHeight: 30, width: '100%' },
    tableHeadRow: {
        margin: "auto",
        flexDirection: "row",
        height: 90,
        width: '100%',
        marginBottom: 0,
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between',
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ccc",
    },
    tableColNum: {
        width: "10%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 1,
        borderTopWidth: 1,
        borderColor: "#ccc"
    },
    tableCol: { borderStyle: "solid", borderWidth: 1, borderColor: "#ccc", height: '100%' },
    tableColXl: {
        width: "65%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 1,
        borderTopWidth: 1,
        borderColor: "#ccc"
    },
    tableCell: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        fontSize: 12,
        fontFamily: 'Montserrat',
        verticalAlign: 'middle',
        textAlign: 'center',
        // margin: '3px 0'
    },
    tableCol3: { width: "3%" },
    tableCol5: { width: "5%" },
    tableCol10: { width: "10%" },
    tableCol15: { width: "15%" },
    tableCol20: { width: "20%" },
    tableCol25: { width: "25%" },
    tableCol30: { width: "30%" },
    tableCol35: { width: "35%" },
    tableCol40: { width: "40%" },
    tableCol50: { width: "50%" },
    tableCol55: { width: "55%" },
    tableCol60: { width: "60%" },
    tableCol70: { width: "70%" },
    tableCol80: { width: "80%" },
    tableCol90: { width: "90%" },
    tableCol100: { width: "100%" },
    tableCol105: { width: "105%" },
    /* TABLE STYLES */

    avatar: { height: 88, right: 39 }
});